export default __webpack_public_path__ + "static/media/sofort.2201dee1.svg";